import { useSelector } from 'react-redux';

export default function UpdateBanner() {
  const { updateAvailable } = useSelector((state) => state.global);

  if (!updateAvailable) return null;

  return (
    <div className="fixed top-0 left-0 w-full z-[99999] bg-[#7C3AED] text-white text-center py-2.5 px-4 text-sm font-medium shadow-md animate-in fade-in slide-in-from-top duration-300">
      Existem atualizações disponíveis. Atualize a página{' '}
      <button
        onClick={() => window.location.reload()}
        className="underline font-bold hover:text-violet-200 transition-colors cursor-pointer bg-transparent border-none text-white text-sm"
      >
        clicando aqui
      </button>
      .
    </div>
  );
}
